import React from 'react'
import Lotteries from '../../Components/Lotteries/Lotteries'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'

const Lottery = () => {
  return (
    <div>
        <Header />
        <Lotteries />
        <Footer />
      
    </div>
  )
}

export default Lottery
